// extracted by mini-css-extract-plugin
module.exports = {"subTotal":"CartSummary-module--subTotal--3YXGH","promoCode":"CartSummary-module--promoCode--1vJbH","btn":"CartSummary-module--btn--ISF1b"};